import MenuIcon from "@mui/icons-material/Menu";
import { useMenu } from "../contexts/menuContext";
import { useState, useEffect } from "react";
// border
export default function ScrollMenu() {
  const [showButton, setShowButton] = useState(false);
  const { openMenu } = useMenu();

  useEffect(() => {
    const handleScroll = () => setShowButton(window.scrollY >= 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <button
      className="scroll-menu-btn"
      onClick={openMenu}
      style={{
        position: "fixed",
        right: "30px",
        top: "40px",
        width: "60px",
        borderRadius: "50%",
        height: "60px",
        cursor: "pointer",
        opacity: showButton ? "1" : "0",
        transition: ".5s",
        visibility: showButton ? "visible" : "hidden",
        backgroundColor: "black",
        // backgroundColor: "rgba(0, 0, 0 , 0.7)",
        zIndex: "100",
        border: "1px solid rgb(45, 42, 42)",
      }}
    >
      <MenuIcon
        className="scroll-menu-icon"
        sx={{ fontSize: "40px", color: "white" }}
      />
    </button>
  );
}
